import React, { useState } from 'react';
import AnalyticsInsights from '../components/Analytics/AnalyticsInsights';
import MoodTrendAnalytics from '../components/Analytics/MoodTrendAnalytics';
import { Calendar, BarChart3, TrendingUp } from 'lucide-react';

const Analytics = () => {
  const [selectedPeriod, setSelectedPeriod] = useState(30);

  const periods = [
    { value: 7, label: '7 Days', icon: Calendar },
    { value: 14, label: '2 Weeks', icon: Calendar },
    { value: 30, label: '30 Days', icon: Calendar },
    { value: 60, label: '2 Months', icon: BarChart3 }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Health Analytics</h1>
          <p className="mt-2 text-gray-600">
            Discover patterns and insights from your health data
          </p>
        </div>

        {/* Period Selector */}
        <div className="mb-6">
          <div className="bg-white rounded-lg shadow-sm p-4">
            <h3 className="text-sm font-medium text-gray-700 mb-3">Analysis Period</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {periods.map((period) => {
                const Icon = period.icon;
                return (
                  <button
                    key={period.value}
                    onClick={() => setSelectedPeriod(period.value)}
                    className={`flex items-center justify-center px-4 py-2 rounded-lg border-2 transition-all ${
                      selectedPeriod === period.value
                        ? 'border-blue-500 bg-blue-50 text-blue-700'
                        : 'border-gray-200 bg-white text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-2" />
                    {period.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Analytics Insights */}
        <AnalyticsInsights days={selectedPeriod} />

        {/* Mood Trend Analytics */}
        <div className="mt-6">
          <MoodTrendAnalytics />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
